import {ScratchStorage} from 'scratch-storage';

import defaultProject from './default-project';

/**
 * Wrapper for ScratchStorage which adds default web sources.
 * @todo make this more configurable
 */
class Storage extends ScratchStorage {
    constructor () {
        super();
        this.cacheDefaultProject();
    }
    addOfficialScratchWebStores () {
        this.addWebStore(
            [this.AssetType.Project],
            this.getProjectGetConfig.bind(this),
            this.getProjectCreateConfig.bind(this),
            this.getProjectUpdateConfig.bind(this)
        );

        this.addWebStore(
            [
                this.AssetType.ImageVector, 
                this.AssetType.ImageBitmap, 
                this.AssetType.Sound,
            ],
            this.getAssetGetConfig.bind(this),
            // We set both the create and update configs to the same method because
            // storage assumes it should update if there is an assetId, but the
            // asset store uses the assetId as part of the create URI.
            this.getAssetCreateConfig.bind(this),
            this.getAssetCreateConfig.bind(this)
        );
        // this.addWebStore(
        //     [this.AssetType.Sound],
        //     asset => `static/extension-assets/scratch3_music/${asset.assetId}.${asset.dataFormat}`
        // );
    }
    setProjectHost (projectHost) {
        this.projectHost = projectHost;
    }
    setProjectToken (projectToken) {
        this.projectToken = projectToken;
    }
    getProjectGetConfig (projectAsset) {
        const path = `${this.projectHost}/${projectAsset.assetId}`;
        const qs = this.projectToken ? `?token=${this.projectToken}` : '';
        return path + qs;
    }
    getProjectCreateConfig () {
        return {
            url: `${this.projectHost}/`,
            withCredentials: true
        };
    }
    getProjectUpdateConfig (projectAsset) {
        return {
            url: `${this.projectHost}/${projectAsset.assetId}`,
            withCredentials: true
        };
    }
    setAssetHost (assetHost) {
        this.assetHost = assetHost;
    }
    getAssetGetConfig (asset) {
        console.log(
            'Load asset:',
            asset.assetId,
            asset.dataFormat,
            asset.assetType
        );

        const localAssets = {
            // SVG unicorn custom
            '16f4250f511e3fa25de8d61263e824ee': '/static/assets/16f4250f511e3fa25de8d61263e824ee.svg'
        };

        if (localAssets[asset.assetId]) {
            console.log('Load local asset URL:', localAssets[asset.assetId]);
            return localAssets[asset.assetId];
        }
        
        // const url = `${this.assetHost}/internalapi/asset/${asset.assetId}.${asset.dataFormat}/get/`;

        // const md5ext = `${asset.assetId}.${asset.dataFormat}`;
        // const url = `https://assets.scratch.mit.edu/${md5ext}`;

        // const url = `https://assets.scratch.mit.edu/${asset.assetId}.${asset.dataFormat}`;

        // console.log('Load asset direct URL:', url);

        // const url = `${this.assetHost}/internalapi/asset/${asset.assetId}.${asset.dataFormat}/get/`;
        const url = `${this.assetHost}/internalapi/asset/${asset.assetId}.${asset.dataFormat}/get/`;

        console.log('Load asset URL:', url);

        // console.log('Load asset URL:', url);

        // return `${this.assetHost}/internalapi/asset/${asset.assetId}.${asset.dataFormat}/get/`;
        // Thử dùng link trực tiếp không qua internalapi xem có bị 403 không
        // return `https://assets.scratch.mit.edu/internalapi/asset/${asset.assetId}.${asset.dataFormat}/get/`;
    
        // Thay vì dùng /internalapi/asset/.../get/
        // Hãy thử dùng link CDN trực tiếp
        // return `https://assets.scratch.mit.edu/internalapi/asset/${asset.assetId}.${asset.dataFormat}/get/`;
    
        // const baseUrl = `https://assets.scratch.mit.edu/internalapi/asset/${asset.assetId}.${asset.dataFormat}/get/`;
        // // Sử dụng một dịch vụ proxy miễn phí để test
        // return `https://cors-anywhere.herokuapp.com/${baseUrl}`;

        // Thêm "/get/" vào cuối là bắt buộc để tránh ERR_INVALID_RESPONSE
        // Thử dùng subdomain 'cdn' thường ít bị chặn Referer hơn
        // return `https://cdn.assets.scratch.mit.edu/internalapi/asset/${asset.assetId}.${asset.dataFormat}/get/`;
        return url;
    }
    getAssetCreateConfig (asset) {
        return {
            // There is no such thing as updating assets, but storage assumes it
            // should update if there is an assetId, and the asset store uses the
            // assetId as part of the create URI. So, force the method to POST.
            // Then when storage finds this config to use for the "update", still POSTs
            method: 'post',
            url: `${this.assetHost}/${asset.assetId}.${asset.dataFormat}`,
            withCredentials: true
        };
    }
    setTranslatorFunction (translator) {
        this.translator = translator;
        this.cacheDefaultProject();
    }
    cacheDefaultProject () {
        const defaultProjectAssets = defaultProject(this.translator);
        defaultProjectAssets.forEach(asset => this.builtinHelper._store(
            this.AssetType[asset.assetType],
            this.DataFormat[asset.dataFormat],
            asset.data,
            asset.id
        ));
    }
}

const storage = new Storage();

storage.setAssetHost('https://assets.scratch.mit.edu');

export default storage;